export const category = {
  name: 'Catégorie',
  status: 'Status',
  all: 'Tous',
  active: 'Activé',
  inactive: 'Désactivé',
  no_categories_yet: "Vous n'avez pas encore de catégories",
  filterBy: 'filtrer par',
};
